/**
 * Comprehensive Phrases Data - Adjectives & Feelings
 * 形容词和情感表达短语
 *
 * 包含be + 形容词的基础表达，约30个短语
 */

import { Phrase } from './phrases-types';

export const adjectivePhrases: Phrase[] = [
  // ==================== 基础形容词短语（be + adjective）====================

  // 情感状态
  {
    id: 'adj_be_happy',
    phrase: 'be happy',
    phonetic: '/biː ˈhæpi/',
    meaning: '开心',
    usageScenario: '描述开心的状态或情绪，用于表达愉悦的心情',
    example: "I'm happy today!",
    exampleTranslation: '我今天很开心！',
    category: 'feelings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_sad',
    phrase: 'be sad',
    phonetic: '/biː sæd/',
    meaning: '难过',
    usageScenario: '描述悲伤或难过的心情',
    example: "He's sad because he lost his toy.",
    exampleTranslation: '他很难过因为他丢了玩具。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_tired',
    phrase: 'be tired',
    phonetic: '/biː ˈtaɪərd/',
    meaning: '累',
    usageScenario: '描述疲惫的状态，通常在运动或工作后',
    example: "I'm tired after running.",
    exampleTranslation: '跑步后我很累。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_hungry',
    phrase: 'be hungry',
    phonetic: '/biː ˈhʌŋɡri/',
    meaning: '饿',
    usageScenario: '描述饥饿的状态，想要吃东西',
    example: "I'm hungry. I want to eat.",
    exampleTranslation: '我饿了。我想吃东西。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_thirsty',
    phrase: 'be thirsty',
    phonetic: '/biː ˈθɜːrsti/',
    meaning: '渴',
    usageScenario: '描述口渴的状态，想要喝水',
    example: "I'm thirsty. Can I have water?",
    exampleTranslation: '我渴了。我可以喝水吗？',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_excited',
    phrase: 'be excited',
    phonetic: '/biː ɪkˈsaɪtɪd/',
    meaning: '兴奋',
    usageScenario: '描述兴奋激动的情绪，通常在期待某事时',
    example: "I'm excited about the trip!",
    exampleTranslation: '我对这次旅行很兴奋！',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_surprised',
    phrase: 'be surprised',
    phonetic: '/biː sərˈpraɪzd/',
    meaning: '惊讶',
    usageScenario: '描述惊讶或吃惊的反应',
    example: "I'm surprised to see you here!",
    exampleTranslation: '我很惊讶在这里见到你！',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_worried',
    phrase: 'be worried',
    phonetic: '/biː ˈwɜːrid/',
    meaning: '担心',
    usageScenario: '描述担忧或焦虑的心情',
    example: "Don't be worried. Everything is OK.",
    exampleTranslation: '别担心。一切都很好。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_nervous',
    phrase: 'be nervous',
    phonetic: '/biː ˈnɜːrvəs/',
    meaning: '紧张',
    usageScenario: '描述紧张不安的状态，通常在考试或演讲前',
    example: "I'm nervous before the test.",
    exampleTranslation: '考试前我很紧张。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_angry',
    phrase: 'be angry',
    phonetic: '/biː ˈæŋɡri/',
    meaning: '生气',
    usageScenario: '描述生气的情绪',
    example: "Don't be angry with me.",
    exampleTranslation: '别生我的气。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // 身体状态
  {
    id: 'adj_be_sick',
    phrase: 'be sick',
    phonetic: '/biː sɪk/',
    meaning: '生病',
    usageScenario: '描述身体不舒服或生病的状态',
    example: "I'm sick today. I can't go to school.",
    exampleTranslation: '我今天生病了。我不能去学校。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_ill',
    phrase: 'be ill',
    phonetic: '/biː ɪl/',
    meaning: '生病',
    usageScenario: '描述生病的状态（比be sick更正式）',
    example: "He's ill and needs rest.",
    exampleTranslation: '他生病了需要休息。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_well',
    phrase: 'be well',
    phonetic: '/biː wel/',
    meaning: '健康',
    usageScenario: '描述身体健康的状态',
    example: "I'm well now. Thank you!",
    exampleTranslation: '我现在好了。谢谢！',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_busy',
    phrase: 'be busy',
    phonetic: '/biː ˈbɪzi/',
    meaning: '忙',
    usageScenario: '描述忙碌的状态，有很多事情要做',
    example: "I'm busy with my homework.",
    exampleTranslation: '我忙着做作业。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_free',
    phrase: 'be free',
    phonetic: '/biː friː/',
    meaning: '有空',
    usageScenario: '描述有空闲时间的状态',
    example: "Are you free this afternoon?",
    exampleTranslation: '你今天下午有空吗？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // 时间状态
  {
    id: 'adj_be_late',
    phrase: 'be late',
    phonetic: '/biː leɪt/',
    meaning: '迟到',
    usageScenario: '描述迟到的情况',
    example: "I'm late for school.",
    exampleTranslation: '我上学迟到了。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_early',
    phrase: 'be early',
    phonetic: '/biː ˈɜːrli/',
    meaning: '早',
    usageScenario: '描述提前到达或提前做某事',
    example: "We're early. Let's wait.",
    exampleTranslation: '我们早到了。等等吧。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_quick',
    phrase: 'be quick!',
    phonetic: '/biː kwɪk/',
    meaning: '快点！',
    usageScenario: '催促某人快点行动',
    example: 'Be quick! We are late!',
    exampleTranslation: '快点！我们迟到了！',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_slow',
    phrase: 'be slow',
    phonetic: '/biː sloʊ/',
    meaning: '慢',
    usageScenario: '描述动作缓慢的状态',
    example: "Don't be slow. Hurry up!",
    exampleTranslation: '别慢吞吞的。快点！',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },

  // 特质描述
  {
    id: 'adj_be_kind',
    phrase: 'be kind',
    phonetic: '/biː kaɪnd/',
    meaning: '善良',
    usageScenario: '描述一个人善良、友好的品质',
    example: 'She is kind to everyone.',
    exampleTranslation: '她对每个人都很善良。',
    category: 'feelings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_clever',
    phrase: 'be clever',
    phonetic: '/biː ˈklevər/',
    meaning: '聪明',
    usageScenario: '描述一个人聪明、机灵',
    example: 'You are clever!',
    exampleTranslation: '你很聪明！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_smart',
    phrase: 'be smart',
    phonetic: '/biː smɑːrt/',
    meaning: '聪明',
    usageScenario: '描述一个人聪明、智慧',
    example: 'He is very smart.',
    exampleTranslation: '他很聪明。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_strong',
    phrase: 'be strong',
    phonetic: '/biː strɒŋ/',
    meaning: '强壮',
    usageScenario: '描述身体强壮或有力量',
    example: 'My dad is strong.',
    exampleTranslation: '我爸爸很强壮。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_weak',
    phrase: 'be weak',
    phonetic: '/biː wiːk/',
    meaning: '虚弱',
    usageScenario: '描述身体虚弱或力量不足',
    example: "I'm weak after the illness.",
    exampleTranslation: '病后我很虚弱。',
    category: 'feelings',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'adj_be_tall',
    phrase: 'be tall',
    phonetic: '/biː tɔːl/',
    meaning: '高',
    usageScenario: '描述身高很高',
    example: 'My brother is tall.',
    exampleTranslation: '我哥哥很高。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_short',
    phrase: 'be short',
    phonetic: '/biː ʃɔːrt/',
    meaning: '矮',
    usageScenario: '描述身高矮或个子不高',
    example: 'My sister is short.',
    exampleTranslation: '我妹妹很矮。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_beautiful',
    phrase: 'be beautiful',
    phonetic: '/biː ˈbjuːtɪfl/',
    meaning: '漂亮',
    usageScenario: '描述人或事物很美丽',
    example: 'The flower is beautiful.',
    exampleTranslation: '这朵花很漂亮。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_careful',
    phrase: 'be careful!',
    phonetic: '/biː ˈkeərfl/',
    meaning: '小心！',
    usageScenario: '提醒某人注意安全或小心',
    example: 'Be careful! There is a car.',
    exampleTranslation: '小心！有车。',
    category: 'actions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'adj_be_ready',
    phrase: 'be ready',
    phonetic: '/biː ˈredi/',
    meaning: '准备好',
    usageScenario: '描述已经准备好做某事',
    example: "I'm ready to go!",
    exampleTranslation: '我准备好出发了！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
];